import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import { sortedDropdownItemLabels } from '../utils/utils';

import CrmTextField from '../components/CrmTextField';
import AAutofill from './AAutofill';
import ReferralCategoryDropdown from './ReferralCategoryDropdown';
import SearchableContactHierarchy from './SearchableContactHierarchy';
import UnaffiliatedContactsBox from './UnaffiliatedContactsBox';

const localStyles = (theme) => ({
  root: {
    marginTop: '8px',
  },
  specifyTextField: {
    marginTop: '-8px',
  },
  autocompleteAndPlusDiv: {
    display: 'inherit',
  },
});

/*
 * Call something like this:
 *
  <ReferralSelectionHierarchy
    required={true}
    searchableContactData={this.searchableContactData}
    chosenReferralCategory={this.state.chosenReferralCategory}
    companyType={this.state.referrerType}
    companyId={this.state.companyId}
    contactId={this.state.contactId}
    chosenWordOfMouthOption={this.state.chosenWordOfMouthOption}
    chosenSocialMediaOption={this.state.chosenSocialMediaOption}
    chosenMediaOption={this.state.chosenMediaOption}
    referralOptionalSpecies={this.state.referralOptionalSpecies}
    onReferralCategoryChange={referralCategory => this.setReferralCategory(referralCategory)}
    onCompanyTypeChange={referrerType => this.selectCategory(referrerType)}
    onCompanyChange={(referrerType, referrerOrgId) => this.selectCompany(referrerType, referrerOrgId)}
    onContactChange={(referrerType, referrerOrgId, personId) => this.selectContact(referrerType, referrerOrgId, personId)}
    onWordOfMouthOptionChange={newChoice => this.setState({ chosenWordOfMouthOption: newChoice })}
    onSocialMediaOptionChange={newChoice => this.setState({ chosenSocialMediaOption: newChoice })}
    onMediaOptionChange={newChoice => this.setState({ chosenMediaOption: newChoice })}
    onOptionalSpeciesChange={newValue => this.setState({ referralOptionalSpecies: newValue })}
    onCreateNewCompany={referrerType => this.forceShowingOfNewReferrerCompanyModal(referrerType)}
    onCreateNewContact={(referrerType, firmId) => this.forceShowingOfNewContactModal(referrerType, firmId)}
  />
 */

class ReferralSelectionHierarchy extends React.Component {
  constructor(props) {
    super(props);
    this.initDropdownOptions();
  }

  initDropdownOptions() {
    this.wordOfMouthOptions = sortedDropdownItemLabels('Word of Mouth Options');
    if (this.wordOfMouthOptions.length === 0) {
      this.wordOfMouthOptions = ['Family', 'Friends', 'Staff', 'Clients/Alumni', 'Contacts of Clients/Alumni', 'Other'];
    }

    this.socialMediaOptions = sortedDropdownItemLabels('Social Media Options');
    if (this.socialMediaOptions.length === 0) {
      this.socialMediaOptions = ['Facebook', 'Twitter', 'Instagram', 'TikTok', 'Other'];
    }

    this.mediaOptions = sortedDropdownItemLabels('Media Options');
    if (this.mediaOptions.length === 0) {
      this.mediaOptions = ['TV', 'Radio', 'Print', 'Internet', 'Other'];
    }
  }

  mediaSpecificationString() {
    switch (this.props.chosenMediaOption) {
      case 'TV':
        return 'Channel';
      case 'Radio':
        return 'Station';
      case 'Print':
        return 'Newspaper or Magazine';
      case 'Internet':
        return 'Site';
      default:
        return 'Specify';
    }
  }

  extractUnaffiliatedContactOptions(searchableContactData) {
    return searchableContactData.contacts.filter((contact) => !contact.businessId);
  }

  render() {
    const {
      classes,
      searchableContactData,
      chosenReferralCategory,
      companyType,
      companyId,
      contactId,
      chosenWordOfMouthOption,
      chosenSocialMediaOption,
      chosenMediaOption,
      referralOptionalSpecies,
      onReferralCategoryChange,
      onCompanyTypeChange,
      onCompanyChange,
      onContactChange,
      onWordOfMouthOptionChange,
      onSocialMediaOptionChange,
      onMediaOptionChange,
      onOptionalSpeciesChange,
      onCreateNewCompany,
      onCreateNewContact,
      required,
    } = this.props;

    const unaffiliatedContactOptions = searchableContactData.contacts.filter((obj) => !obj.businessId);
    const chosenUnaffiliatedOption = unaffiliatedContactOptions.find((option) => option.personId === contactId);

    return (
      <Grid item className={classes.root} container spacing={2} xs={12} md={12}>
        <Grid item xs={12} md={3}>
          <ReferralCategoryDropdown
            required={required}
            value={chosenReferralCategory}
            onChange={(newCategory) => onReferralCategoryChange(newCategory)}
          />
        </Grid>
        {chosenReferralCategory === 'Company / Organization' && (
          <Grid item xs={12} md={9}>
            <SearchableContactHierarchy
              required={required}
              data={searchableContactData}
              referrerType={companyType}
              companyId={companyId}
              contactId={contactId}
              newOrgTypeFunc={() => alert('Should show Modal to define a new Category')}
              newCompanyFunc={(referrerType) => onCreateNewCompany(referrerType)}
              newReferralContactFunc={(referrerType, firmId) => onCreateNewContact(referrerType, firmId)}
              onOrgTypeSelect={(referrerType) => onCompanyTypeChange(referrerType)}
              onCompanySelect={(referrerType, referrerOrgId) => onCompanyChange(referrerType, referrerOrgId)}
              onContactSelect={(referrerType, referrerOrgId, personId) =>
                onContactChange(referrerType, referrerOrgId, personId)
              }
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Word of Mouth' && (
          <Grid item xs={12} md={3}>
            <AAutofill
              required={required}
              label="Source"
              options={this.wordOfMouthOptions}
              value={chosenWordOfMouthOption}
              onChange={(newChoice) => onWordOfMouthOptionChange(newChoice)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Word of Mouth' && chosenWordOfMouthOption === 'Other' && (
          <Grid className={classes.specifyTextField} item xs={12} md={3}>
            <CrmTextField
              label="Specify (Optional)"
              fullWidth
              value={referralOptionalSpecies}
              onChange={(event) => onOptionalSpeciesChange(event.target.value)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Word of Mouth' && chosenWordOfMouthOption === 'Other' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Word of Mouth' &&
          chosenWordOfMouthOption &&
          chosenWordOfMouthOption !== 'Other' && (
            <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
              <UnaffiliatedContactsBox
                unaffiliatedContactOptions={unaffiliatedContactOptions}
                chosenOption={chosenUnaffiliatedOption}
                onContactChange={(personId) => onContactChange(null, 0, personId)}
                onCreateNewContact={() => onCreateNewContact(null, 0)}
              />
            </Grid>
          )}

        {chosenReferralCategory === 'Internet Search' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Social Media' && (
          <Grid item xs={12} md={3}>
            <AAutofill
              required={required}
              label="Medium"
              options={this.socialMediaOptions}
              value={chosenSocialMediaOption}
              onChange={(newChoice) => onSocialMediaOptionChange(newChoice)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Social Media' && chosenSocialMediaOption === 'Other' && (
          <Grid className={classes.specifyTextField} item xs={12} md={3}>
            <CrmTextField
              label="Specify (Optional)"
              fullWidth
              value={referralOptionalSpecies}
              onChange={(event) => onOptionalSpeciesChange(event.target.value)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Social Media' && chosenSocialMediaOption === 'Other' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Social Media' &&
          chosenSocialMediaOption &&
          chosenSocialMediaOption !== 'Other' && (
            <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
              <UnaffiliatedContactsBox
                unaffiliatedContactOptions={unaffiliatedContactOptions}
                chosenOption={chosenUnaffiliatedOption}
                onContactChange={(personId) => onContactChange(null, 0, personId)}
                onCreateNewContact={() => onCreateNewContact(null, 0)}
              />
            </Grid>
          )}

        {chosenReferralCategory === 'Media' && (
          <Grid item xs={12} md={3}>
            <AAutofill
              required={required}
              label="Medium"
              options={this.mediaOptions}
              value={chosenMediaOption}
              onChange={(newChoice) => onMediaOptionChange(newChoice)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Media' && chosenMediaOption === 'Other' && (
          <Grid className={classes.specifyTextField} item xs={12} md={3}>
            <CrmTextField
              label={this.mediaSpecificationString() + ' (Optional)'}
              fullWidth
              value={referralOptionalSpecies}
              onChange={(event) => onOptionalSpeciesChange(event.target.value)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Media' && chosenMediaOption === 'Other' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Media' && chosenMediaOption && chosenMediaOption !== 'Other' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {chosenReferralCategory === 'Unknown' && (
          <Grid item xs={12} md={3} className={classes.autocompleteAndPlusDiv}>
            <UnaffiliatedContactsBox
              unaffiliatedContactOptions={unaffiliatedContactOptions}
              chosenOption={chosenUnaffiliatedOption}
              onContactChange={(personId) => onContactChange(null, 0, personId)}
              onCreateNewContact={() => onCreateNewContact(null, 0)}
            />
          </Grid>
        )}

        {!chosenReferralCategory && <div>{null}</div>}
      </Grid>
    );
  }
}

export default withStyles(localStyles)(ReferralSelectionHierarchy);
